<template>
  <div>
    <div
      v-if="user.role == 'participant'"
      style="display: inline-block"
      class="mr-3"
    >
      Available collateral: <b>{{ availableCollateral }}</b>
    </div>

    <div style="display: inline-block">
      <a-dropdown :trigger="['click']" placement="bottomLeft">
        <div :class="$style.dropdown">
          <a-badge>
            <a-avatar
              shape="square"
              icon="user"
              size="large"
              :class="$style.avatar"
            />
          </a-badge>
        </div>
        <a-menu slot="overlay">
          <a-menu-item>
            <div>
              <strong
                >{{ $t('topBar.profileMenu.hello') }},
                {{ user.name || 'Anonymous' }}</strong
              >
            </div>
            <div>
              <strong class="mr-1">{{ $t('topBar.profileMenu.role') }}:</strong>
              {{ user.role || '—' }}
            </div>
          </a-menu-item>
          <a-menu-divider />
          <!-- <a-menu-item>
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.email') }}:</strong>
          {{ user.email || '—' }}
        </div> 
        <div>
          <strong class="mr-1">{{ $t('topBar.profileMenu.phone') }}:</strong> —
        </div> 
      </a-menu-item>
      <a-menu-divider /> -->
          <a-menu-item>
            <a href="javascript: void(0);" @click="myProfile">
              <i class="fe fe-user mr-2"></i>
              {{ $t('topBar.profileMenu.editProfile') }}
            </a>
          </a-menu-item>
          <a-menu-divider />
          <a-menu-item>
            <a href="javascript: void(0);" @click="logout">
              <i class="fe fe-log-out mr-2"></i>
              {{ $t('topBar.profileMenu.logout') }}
            </a>
          </a-menu-item>
        </a-menu>
      </a-dropdown>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { formatMoney } from '@/utilities'

export default {
  computed: {
    ...mapState(['user']),
    availableCollateral() {
      var available =
        this.user.participant != undefined
          ? this.user.participant.availableCollateral
          : 0.0
      return formatMoney(available)
    },
    loading() {
      return this.$store.state.user.loading
    },
  },
  data: function () {
    return {
      count: 7,
    }
  },
  methods: {
    addCount() {
      this.count++
    },
    logout() {
      this.$store.dispatch('user/LOGOUT')
    },
    myProfile() {
      this.$router.push({ path: '/profile' })
    },
  },
}
</script>

<style lang="scss" module>
@import './style.module.scss';
</style>
